import { render, staticRenderFns } from "./OpenBillingProducts.vue?vue&type=template&id=189b4824&scoped=true&"
import script from "./OpenBillingProducts.vue?vue&type=script&lang=js&"
export * from "./OpenBillingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b4824",
  null
  
)

export default component.exports